"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartApi = exports.CART_COMMANDS_URL = void 0;
var tslib_1 = require("tslib");
var commands_executor_1 = tslib_1.__importDefault(require("@wix/wixstores-client-core/dist/es/src/commands-executor"));
exports.CART_COMMANDS_URL = '/_api/wix-ecommerce-renderer-web/store-front/cart/{commandName}?returnCartSummary=false';
var CartApi = /** @class */ (function () {
    function CartApi(httpClient) {
        this.commandsExecutor = new commands_executor_1.default(exports.CART_COMMANDS_URL, httpClient);
    }
    CartApi.prototype.updateQuantity = function (cartItemId, quantity) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = { cartItemId: cartItemId, quantity: quantity };
                        return [4 /*yield*/, this.commandsExecutor.execute('UpdateCartItemCommand', queryParams)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    CartApi.prototype.setCartAddresses = function (cartId, address) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.execute('SetCartAddressesAndDestinationFromSingleAddressCommand', {
                            cartId: cartId,
                            address: address,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    CartApi.prototype.setCartBillingAddresses = function (cartId, address) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.execute('SetCartBillingAddressCommand', {
                            cartId: cartId,
                            billingAddress: address,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    CartApi.prototype.setShippingAddressesForFastFlow = function (cartId, address) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = { cartId: cartId, address: address };
                        return [4 /*yield*/, this.commandsExecutor.execute('SetCartShippingAddressesForFastFlowEstimationCommand', data)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    return CartApi;
}());
exports.CartApi = CartApi;
//# sourceMappingURL=CartApi.js.map